import React from 'react';
import classNames from "classnames";

const EclipseGoTo = ({
  currentPage,
  ...props
}) => {


  const classes = [
    "relative",
    "inline-flex",
    "items-center",
    "border",
    "border-gray-300",
    "bg-white",
    "px-4",
    "py-2",
    "text-sm",
    "font-medium",
    "text-gray-700"
  ];

  return (<span key={"more-" + currentPage}
                className={classNames(classes)}>...</span>);
};

export default EclipseGoTo
